module.exports = __webpack_public_path__ + "img/logo.461de08f.png";